export default __webpack_public_path__ + "static/media/img-0553-denmark-half-face.8941ecbe.png";